import { useMemo } from 'react';

import { BREAKPOINTS } from '../constants/breakpoints';
import { useViewportDimensions } from './useViewportDimensions';

export type Breakpoint = {
  name: 'sm' | 'md' | 'lg';
};

/**
 * Determine the current breakpoint based on the viewport width.
 * Always returns as "sm" when used server side.
 *
 * @returns An object representing the current breakpoint.
 */
export const useBreakpoint = (): Breakpoint => {
  const { width } = useViewportDimensions();

  return useMemo(() => {
    if (width >= BREAKPOINTS.LG) return { name: 'lg' };
    if (width >= BREAKPOINTS.MD) return { name: 'md' };
    return { name: 'sm' };
  }, [width]);
};
